import { ErrorMessage } from "formik";
import { AddAccountStepProps } from "./StepModel";
import { linkClientAccountWithEmail } from "../AddAccountSlice";
import OtpInput from "react-otp-input";

export const EmailVerificationCodeStep: React.FC<AddAccountStepProps> = ({
  currentStep,
  formikProps,
}: AddAccountStepProps) => (
  <>
    <p className="col-lg-4 col-form-label required fw-bold fs-6">Email Verification Code</p>
    <div className="col-lg-8">
      <div className="row">
        <div className="col-lg-6 fv-row">
          <OtpInput
            aria-label="Email Verification Code"
            inputStyle="inputStyle"
            value={formikProps.values.emailVerificationCode}
            onChange={(otp: string) => {
              formikProps.setFieldValue("emailVerificationCode", otp);
            }}
            numInputs={6}
            inputType="number"
            renderSeparator={(index) => (index === 2 ? <span>-</span> : "")}
            renderInput={(props, index) => (
              <input {...props} data-test-id={`add-account-form__verification-code-input-${index}`} />
            )}
          />
          <div className="fv-plugins-message-container">
            <div className="fv-help-block">
              <ErrorMessage name="emailVerificationCode" key={currentStep.toString()} />
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);

export const EmailVerificationCodeSubmit = ({ values, thunkDispatch }) => {
  thunkDispatch(
    linkClientAccountWithEmail({
      emailAddress: values.emailAddress,
      emailVerificationCode: values.emailVerificationCode,
      clientAccountNumber: values.clientAccountNumber,
    })
  );
};
